import React, {useEffect} from "react"
import Fireworks from "@fireworks-js/react"
import ScreenBarPartner, {ScreenProgressBar} from "./components/screen-bar-partner"
import ScreenDonSection from "./components/screen-don-section"

export default function CustomRouan({context, loading, campagneData}) {
    const screenOptions = campagneData?.screenOptions || {}

    useEffect(() => {
        document.body.style.overflow = "hidden"
        document.body.style.cursor = "none"
    }, [])

    if (loading) {
        return (
            <div className="screen" style={{aspectRatio: "16/9", position: "relative", backgroundColor: "#000"}}/>
        )
    }

    return (
        <div className="screen custom-rouan-screen" style={{
            aspectRatio: "16/9",
            position: "relative",
            overflow: "hidden",
            backgroundImage: "url(/campagne/screen/custom-rouan/2YK.jpg)",
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "100vw",
            height: "100vh"
        }}>
            <style jsx global>{`
                @font-face {
                    font-family: "DeseoMedium";
                    src: url("/campagne/screen/custom-rouan/Deseo Medium Regular.otf") format("opentype");
                    font-weight: 400;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "DeseoMedium";
                    src: url("/campagne/screen/custom-rouan/Deseo Medium Bold.otf") format("opentype");
                    font-weight: 700;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "DeseoMedium";
                    src: url("/campagne/screen/custom-rouan/Deseo Medium Black.otf") format("opentype");
                    font-weight: 900;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "DeseoMedium";
                    src: url("/campagne/screen/custom-rouan/Deseo Medium Extra Light.otf") format("opentype");
                    font-weight: 200;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "DeseoMedium";
                    src: url("/campagne/screen/custom-rouan/Deseo Medium Thin.otf") format("opentype");
                    font-weight: 100;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "ProximaNovaRouan";
                    src: url("/campagne/screen/custom-rouan/Proxima Nova Regular.woff2") format("woff2"),
                         url("/campagne/screen/custom-rouan/Proxima Nova Regular.otf") format("opentype");
                    font-weight: 400;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "ProximaNovaRouan";
                    src: url("/campagne/screen/custom-rouan/Proxima Nova Bold.otf") format("opentype");
                    font-weight: 700;
                    font-style: normal;
                    font-display: swap;
                }
                @font-face {
                    font-family: "ProximaNovaRouan";
                    src: url("/campagne/screen/custom-rouan/Proxima Nova Black.otf") format("opentype");
                    font-weight: 900;
                    font-style: normal;
                    font-display: swap;
                }

                @keyframes rouanScreenDonFadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                .custom-rouan-screen .screen-don-card {
                    animation-duration: 1s;
                    animation-fill-mode: both;
                }
                .custom-rouan-screen .screen-don-card.screenDonFadeIn {
                    animation-name: rouanScreenDonFadeIn;
                }
                .custom-rouan-screen .screen-don-card.screenDonFadeOut {
                    display: none;
                }
            `}</style>

            <ScreenBarPartner context={context} campagneData={campagneData}/>

            <ScreenDonSection context={context} campagneData={campagneData}/>

            <ScreenProgressBar campagneData={campagneData}/>

            {screenOptions.forceCelebration && (
                <Fireworks
                    autostart
                    options={{intensity: 30, particles: 100, traceLength: 1, opacity: 0.2}}
                    style={{
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        position: "fixed",
                        background: "transparent"
                    }}
                />
            )}
        </div>
    )
}
